import React from 'react'
import { ButtonBase } from '@material-ui/core'
import * as css from '../User.styles'
import { useMutation } from '@apollo/client'
import cdrEnergy from 'graphql/mutations/cdrEnergy'

type Props = {
    userID: string
}
export const CdrEnergyButtons = ({userID}: Props) => {
    const [q, res] = useMutation(cdrEnergy, {
        onCompleted: (data) => {
            alert('CDR Energy Insight generated successfully!')
        }, onError: (error) => {
            console.error('Error generating CDR Energy Insight:', error)
            alert('Failed to generate CDR Energy Insight')
        }, 
        refetchQueries: ['insights'],
    })

    const genInsight = async (type: string) => {

        console.log('generating cdr energy insight')
        try {
            const result = await q({
                variables: {
                    adminUserID: userID,
                    insightType: type,
                },
            })
            console.log('CDR Energy Insight generated:', result.data)
        } catch (error) {
            console.error('Error generating CDR Energy Insight:', error)
        }
    }

    return (
        <>
        { res.loading ? 
            <div className={css.loading}>Generating...</div> : 
            <>
            <ButtonBase
                className={css.button}
                onClick={(e) => {
                    genInsight('billing')
                }}
                >
                ENERGY-BILLING
            </ButtonBase>
            <div />
            <ButtonBase
                className={css.button}
                onClick={(e) => {
                    genInsight('usage')
                }}
                >
                ENERGY-USAGE
            </ButtonBase>
            <div />
            </>
        }
        </>
    )
}